import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Controller, useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'

import {yupResolver} from '@hookform/resolvers/yup'
import Select from 'react-select'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import {createReserveBedProductTypeGuest} from '../../../../models/ckecking.model'
import {
  createReserveBedProductTypeGuestService,
  getproductTypeGuest,
} from '../../../../services/checking.service'
import {MasterModel} from '../../../modules/models'
import {getMasterModuleService} from '../../../modules/services'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getProductsCheckin: () => void
}

const ModalAddProduct: FC<Props> = ({show, setShow, getProductsCheckin}) => {
  const {currentTabItem} = useHoteleria()
  const [guestTypes, setGuestTypes] = useState<MasterModel[] | any>([])
  const [productTypeGuest, setProductTypeGuest] = useState<MasterModel[] | any>([])
  const [loading, setLoading] = useState(false)

  //const [data, setData] = useState([])

  const handleClose = () => {
    setShow(false)
  }

  const getGuestTypes = async () => {
    setProductTypeGuest([])
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHuesped',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setGuestTypes(mappedModuleTypes)
    } catch (error) {
      setGuestTypes([])
    }
  }
  const getProductsFromType = async (TipoHuespedId: string) => {
    try {
      const response = await getproductTypeGuest({
        pageNumber: 1,
        size: 100,
        TipoHuespedId: TipoHuespedId,
      })
      const data = response.data.data
      const mappedProductsFromTypes = data?.map((moduleType) => ({
        value: moduleType.Id,
        label: moduleType.Producto_descripcion,
      }))
      setProductTypeGuest(mappedProductsFromTypes)
    } catch (error) {
      setProductTypeGuest([])
    }
  }

  useEffect(() => {
    getGuestTypes()
    reset()
    setLoading(false)
  }, [show])

  const addProductSchema = Yup.object().shape({
    TipoHuespedId: Yup.string().required('Estatus de huésped es requerido'),
    ProductoTipoHuespedId: Yup.string().required('Producto es requerido'),
    Cantidad: Yup.number().required('Cantidad es requerido').min(1, 'La Cantidad mínima es 1'),
    //Observaciones: Yup.string().required("Cantidad es requerido"),
  })

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    watch,
    setError,
    control,
    formState: {errors},
  } = useForm<createReserveBedProductTypeGuest>({
    resolver: yupResolver(addProductSchema),
    defaultValues: {
      Cantidad: 1,
    },
  })

  useEffect(() => {
    const TipoHuespedId = watch('TipoHuespedId')
    if (TipoHuespedId) {
      getProductsFromType(TipoHuespedId)
      setValue('ProductoTipoHuespedId', '')
      setError('ProductoTipoHuespedId', {})
    }
  }, [watch('TipoHuespedId')])

  const onSubmit = async (data: createReserveBedProductTypeGuest) => {
    //getProductsCheckin(data)
    data.ReservaCamaId = currentTabItem.idToEdit as string

    setLoading(true)
    // setIsFiltred(true);
    const {data: response} = await createReserveBedProductTypeGuestService(data)

    setLoading(false)

    if (!response.error) {
      getProductsCheckin()
      setShow(false)
      Swal.fire('Producto Agregado', '', 'success')
    } else {
      Swal.fire('Ups', response.message, 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Agregar producto</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='row p-3 pb-5'>
              <div className='col-md-6 '>
                <label className='required form-label'>Estatus de Huésped</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='TipoHuespedId'
                    render={({field}) => (
                      <Select
                        {...field}
                        {...register('TipoHuespedId')}
                        key={field.value}
                        className='w-100'
                        options={guestTypes}
                        placeholder='Selecciona un estatus de huésped'
                        value={guestTypes?.find((c: {value: string}) => c.value === field.value)}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.TipoHuespedId?.message?.toString()}
                  </p>
                </div>
              </div>
              <div className='col-md-6'>
                <label className='required form-label'>Producto</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='ProductoTipoHuespedId'
                    render={({field}) => (
                      <Select
                        {...field}
                        {...register('ProductoTipoHuespedId')}
                        key={field.value}
                        className='w-100'
                        options={productTypeGuest}
                        placeholder='Selecciona un producto'
                        value={productTypeGuest?.find(
                          (c: {value: string}) => c.value === field.value,
                        )}
                        onChange={(val) => field.onChange(val ? val.value : '')}
                      />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.ProductoTipoHuespedId?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='row p-3 pb-5'>
              <div className='col-md-4 '>
                <label className='required form-label'>Cantidad</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='Cantidad'
                    render={({field}) => (
                      <input {...register('Cantidad')} type='number' className='form-control' />
                    )}
                  />
                  <div
                    className={'col-12'}
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.Cantidad?.message?.toString()}
                  </div>
                </div>
              </div>
              <div className='col-md-8 '>
                <label className='form-label'>Observaciones</label>
                <div className='input-group input-group-sm'>
                  <Controller
                    control={control}
                    name='Observaciones'
                    render={({field}) => (
                      <input {...register('Observaciones')} type='text' className='form-control' />
                    )}
                  />
                  <p
                    style={{
                      marginBottom: '0',
                      fontSize: '10px',
                      fontWeight: '600',
                      color: 'red',
                      marginLeft: '5px',
                    }}
                  >
                    {errors.Observaciones?.message?.toString()}
                  </p>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                {!loading && 'Agregar'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Agregando...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddProduct}
